<template>
    <div class="stepper-cont-demo flex-disp">
        <v-stepper v-model="currentStep">
            <v-stepper-header>
                <v-stepper-step :complete="currentStep > 1" step="1">
                    {{ $t('indicators.indicators_wizard.headers.basic_data') }}
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="currentStep > 2" step="2">
                    {{ $t('indicators.indicators_wizard.headers.selection') }}
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step :complete="currentStep > 3" step="3">
                    {{ $t('indicators.indicators_wizard.headers.setting') }}
                </v-stepper-step>
                <v-divider></v-divider>
                <v-stepper-step step="4">
                    {{ $t('indicators.indicators_wizard.headers.confirmation') }}
                </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items class="mx-8">
                <v-stepper-content step="1">
                    <v-card class="mb-12" flat>
                        <indicator-wizard-step1/>
                    </v-card>
                    <v-btn class="v-btn--primary" @click="openConfirmDialog">
                        {{ $t('indicators.continue') }}
                    </v-btn>

                    <v-btn class="v-btn--secondary">
                        {{ $t('indicators.cancel') }}
                    </v-btn>
                </v-stepper-content>

                <v-stepper-content step="2">
                    <v-card
                    class="mb-12"
                    color="grey lighten-1"
                    height="200px"
                    ></v-card>

                    <v-btn class="v-btn--primary" @click="currentStep = 3">
                        {{ $t('indicators.continue') }}
                    </v-btn>

                    <v-btn class="v-btn--secondary">
                        {{ $t('indicators.cancel') }}
                    </v-btn>
                </v-stepper-content>

                <v-stepper-content step="3">
                    <v-card
                    class="mb-12"
                    color="grey lighten-1"
                    height="200px"
                    ></v-card>

                    <v-btn class="v-btn--primary" @click="currentStep = 4">
                        {{ $t('indicators.continue') }}
                    </v-btn>

                    <v-btn class="v-btn--secondary">
                        {{ $t('indicators.cancel') }}
                    </v-btn>
                </v-stepper-content>            

                <v-stepper-content step="4">
                    <v-card class="mb-12" flat>
                        <indicator-wizard-step4/>
                    </v-card>
                    <v-btn class="v-btn--primary"
                            @click="openConfirmFinishDialog">
                        {{ $t('indicators.continue') }}
                    </v-btn>
                    <v-btn class="v-btn--secondary">
                        {{ $t('indicators.cancel') }}
                    </v-btn>
                </v-stepper-content>
            </v-stepper-items>
        </v-stepper>
        <confirm-next-step-dialog
            :showDialog="showNextStepDialog"
            @confirmDialog="goToNextStep"
            @cancelConfirmDialog="hideConfirmDialog"/>
        <confirm-finish-process-dialog
            :showDialog="showFinishProcessDialog"
            @confirmDialog="finishProcess"
            @cancelConfirmDialog="hideFinishProcessDialog"/>
    </div>
</template>
<script>
import IndicatorWizardStep1 from "./IndicatorWizardStep1";
import IndicatorWizardStep4 from "./IndicatorWizardStep4";
import ConfirmNextStepDialog from "./ConfirmNextStepDialog";
import ConfirmFinishProcessDialog from "./ConfirmFinishProcessDialog";

export default {
    name: "IndicatorsWizard",

    components: {
        IndicatorWizardStep1,
        IndicatorWizardStep4,
        ConfirmNextStepDialog,
        ConfirmFinishProcessDialog,
    },

    props: {
        type: {
            type: Object,
        },
    },

    data() {
        return {
            currentStep: 1,
            showNextStepDialog: false,
            showFinishProcessDialog: false,
        }
    },

    methods: {
        openConfirmDialog() {
            this.showNextStepDialog = true
        },

        openConfirmFinishDialog() {
            this.showFinishProcessDialog = true
        },

        hideConfirmDialog() {
            this.showNextStepDialog = false
        },

        hideFinishProcessDialog() {
            this.showFinishProcessDialog = false
        },

        goToNextStep() {
            this.hideConfirmDialog()
            this.currentStep = 4
            //this.currentStep++
        },

        finishProcess() {
            this.hideFinishProcessDialog()
            this.$inertia.get(route('indicators.index', {'type': this.type.id}))
        },
    }
}
</script>

<style scoped>

</style>